import React from "react";
import { routeNames } from "utils/routeNames";

const Courses = React.lazy(() => import("admin/app/pages/Courses"));
const CreateCourse = React.lazy(
  () => import("admin/app/pages/CreateCourse")
);
const Course = React.lazy(() => import("admin/app/pages/Course"));
const EditCourse = React.lazy(
  () => import("admin/app/pages/EditCourse")
);
const QuestionForm = React.lazy(
  () => import("admin/app/pages/CreateQuiz")
);
const User = React.lazy(() => import("admin/app/pages/User"));
const Users = React.lazy(() => import("admin/app/pages/Users"));
const AdminUsers = React.lazy(() => import("admin/app/pages/admin-users"));
const AdminNewInterview = React.lazy(() => import("admin/app/pages/create-interview"));
const AdminInterviews = React.lazy(() => import("admin/app/pages/interviews"));

export const adminRoutes: {
  path: string;
  Component: React.LazyExoticComponent<() => JSX.Element>;
}[] = [

  {
    path: routeNames.adminInterviews,
    Component: AdminInterviews,
  },
  {
    path: routeNames.adminCreateInterview,
    Component: AdminNewInterview
  },{
    path: routeNames.adminUsers,
    Component: Users,
  },
  {
    path: routeNames.adminUser,
    Component: User,
  },
  {
    path: routeNames.adminCourseMgt,
    Component: Courses,
  },
  {
    path: routeNames.adminCreateCourse,
    Component: CreateCourse,
  },
  {
    path: routeNames.adminGstForm,
    Component: QuestionForm,
  },
  {
    path: routeNames.adminEditCourse,
    Component: EditCourse,
  },
  {
    path: routeNames.adminCourse,
    Component: Course,
  },
  {
    path: routeNames.adminAdminUsers,
    Component: AdminUsers
  }
];


const AdminLogin = React.lazy(() => import("dashboard/app/pages/Auth/AdminLogin"));
export const adminAuthRoutes: {
  path: string;
  Component: React.LazyExoticComponent<() => JSX.Element>;
}[] = [{
    path: routeNames.adminLogin,
    Component: AdminLogin,
  },
]
